import {Grid2} from '@mui/material';

import PackagesItemSkeleton from './PackagesItemSkeleton';

const PackagesSkeleton = () => (
  <Grid2 pt={1} container spacing={2}>
    {[...Array(9)].map((_, index) => (
      <PackagesItemSkeleton key={index} />
    ))}
  </Grid2>
);

export default PackagesSkeleton;
